<ct-lib-modal
  [label]="'company-tool.snippets.tos-modal.label' | transloco"
  [closeable]="false"
  [footer]="tosModalFooter"
  #modal
>
  <p
    [innerHTML]="
      'company-tool.snippets.tos-modal.info'
        | transloco
          : {
              date: latestChange ? (latestChange | date: 'longDate') : '',
            }
    "
  ></p>
</ct-lib-modal>
<ng-template #tosModalFooter>
  <div class="footer d-flex flex-wrap align-items-center gap-2">
    <app-button variant="white-red" (click)="confirmModal.modal.open()">
      {{ 'company-tool.snippets.tos-modal.decline-button' | transloco }}
    </app-button>
    <app-button variant="white-grey" (click)="skip()">
      {{ 'company-tool.snippets.tos-modal.skip-button' | transloco }}
    </app-button>
    <app-button (click)="accept()">
      {{ 'company-tool.snippets.tos-modal.accept-button' | transloco }}
    </app-button>
  </div>
</ng-template>
<ct-lib-confirm-modal (onConfirm)="decline()" #confirmModal>
  <p>{{ 'company-tool.snippets.tos-modal.confirm-modal-info' | transloco }}</p>
</ct-lib-confirm-modal>
